import { aksaraAdminAuthRepository } from '@/projects/aksara/repositories/adminAuthRepository';
import type { AksaraAdminSession } from '@/projects/aksara/models/adminAuth.model';

export const aksaraAdminAuthUsecase = {
  async login(googleToken: string): Promise<AksaraAdminSession> {
    const tokens = await aksaraAdminAuthRepository.login(googleToken);
    const user = await aksaraAdminAuthRepository.profile(tokens.token);
    if (!user.roles.includes('ADMIN')) throw new Error('ADMIN_REQUIRED');
    return { ...tokens, project: 'aksara', user };
  },

  async profile(token: string) {
    const user = await aksaraAdminAuthRepository.profile(token);
    if (!user.roles.includes('ADMIN')) throw new Error('ADMIN_REQUIRED');
    return user;
  },
};
